"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aion_1 = __importDefault(require("@adoratorio/aion"));
var declarations_1 = require("./declarations");
var easing_1 = __importDefault(require("./easing"));
var utils_1 = require("./utils");
var Apollo = /** @class */ (function () {
    function Apollo(options) {
        var _this = this;
        this.elements = [];
        this.domElements = [];
        this._boundingCursor = { x: 0, y: 0 };
        this._coords = { x: 0, y: 0 };
        this._mousePosition = { x: 0, y: 0 };
        this._cursorPosition = { x: 0, y: 0 };
        this._cursorPositionPrev = { x: 0, y: 0 };
        this._velocity = { x: 0, y: 0 };
        this._direction = { x: 0, y: 0 };
        this.customCursor = { x: 0, y: 0 };
        this._distanceFromCenter = 0;
        this._distanceFromBorder = 0;
        this._pulling = false;
        this._pushing = false;
        this.status = false;
        this.leave = false;
        this.first = true;
        this.bindMouse = function () {
            document.body.addEventListener('mousemove', _this.mouseMove, { passive: true });
            if (_this.options.detectTouch) {
                document.body.addEventListener('touchstart', _this.touchMove, { passive: true });
                document.body.addEventListener('touchmove', _this.touchMove, { passive: true });
            }
        };
        this.unbindMouse = function () {
            document.body.removeEventListener('mousemove', _this.mouseMove);
            if (_this.options.detectTouch) {
                document.body.removeEventListener('touchstart', _this.touchMove);
                document.body.removeEventListener('touchmove', _this.touchMove);
            }
        };
        this.mouseMove = function (event) {
            _this._mousePosition = {
                x: event.clientX,
                y: event.clientY,
            };
        };
        this.touchMove = function (event) {
            _this._mousePosition = {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY,
            };
        };
        this.setBoundingCursor = function (customCursor) {
            var width = 0;
            var height = 0;
            if (_this.options.cursor === null && customCursor !== undefined) {
                width = customCursor.x;
                height = customCursor.y;
            }
            else {
                width = _this.options.cursor.getBoundingClientRect().width;
                height = _this.options.cursor.getBoundingClientRect().height;
            }
            return _this._boundingCursor = {
                x: width / 2,
                y: height / 2,
            };
        };
        this.frame = function (delta) {
            _this.timelineCursor.final = {
                x: _this._mousePosition.x,
                y: _this._mousePosition.y,
            };
            var deltaT = Math.min(Math.max(delta, 0), _this.options.easing.duration);
            var t = _this.options.easing.mode(deltaT / _this.options.easing.duration);
            _this.timelineCursor.current.x = _this.timelineCursor.initial.x + (t * (_this.timelineCursor.final.x - _this.timelineCursor.initial.x));
            _this.timelineCursor.current.y = _this.timelineCursor.initial.y + (t * (_this.timelineCursor.final.y - _this.timelineCursor.initial.y));
            var cursor = {
                x: _this.timelineCursor.current.x - _this._boundingCursor.x,
                y: _this.timelineCursor.current.y - _this._boundingCursor.y,
            };
            var roundedCursor = {
                x: Math.round(_this.timelineCursor.current.x - _this._boundingCursor.x),
                y: Math.round(_this.timelineCursor.current.y - _this._boundingCursor.y),
            };
            _this._cursorPosition = _this.options.renderByPixel ? roundedCursor : cursor;
            if (_this.options.mode === 'mouse') {
                _this._coords = _this._mousePosition;
            }
            else if (_this.options.mode === 'cursor') {
                _this._coords = _this._cursorPosition;
            }
            if (_this.options.type === Apollo.TYPE.HTML &&
                _this.options.hiddenUntilFirstInteraction &&
                _this.timelineCursor.initial.x !== _this.timelineCursor.current.x &&
                _this.first) {
                setTimeout(function () {
                    _this.options.cursor.style.display = 'block';
                    _this.first = false;
                }, _this.options.easing.duration);
            }
            if (!_this._pushing && !_this.first && _this.options.type === Apollo.TYPE.HTML) {
                _this.options.cursor.style.webkitTransform = "translate3d(" + _this._cursorPosition.x + "px, " + _this._cursorPosition.y + "px, 0px)";
                _this.options.cursor.style.transform = "translate3d(" + _this._cursorPosition.x + "px, " + _this._cursorPosition.y + "px, 0px)";
            }
            _this.timelineCursor.initial.x = _this.timelineCursor.current.x;
            _this.timelineCursor.initial.y = _this.timelineCursor.current.y;
            _this._velocity = {
                x: (cursor.x - _this._cursorPositionPrev.x) / delta,
                y: (cursor.y - _this._cursorPositionPrev.y) / delta,
            };
            _this._direction.x = _this._velocity.x > 0 ? 1 : -1;
            _this._direction.y = _this._velocity.y > 0 ? 1 : -1;
            _this._velocity.x = Math.abs(_this._velocity.x);
            _this._velocity.y = Math.abs(_this._velocity.y);
            _this._cursorPositionPrev = cursor;
            _this.options.onUpdate(_this._coords);
            if (_this.options.emitGlobal) {
                var eventInit = {};
                eventInit.detail = _this._coords;
                var customEvent = new CustomEvent('apollo-update', eventInit);
                window.dispatchEvent(customEvent);
            }
        };
        this.cursorCheck = function (delta) {
            _this.status = false;
            _this.elements.forEach(function (element) {
                var offset = element.target.offset;
                element.rect = _this.inRect(element.domElement, offset);
                if (element.rect.check && getComputedStyle(element.domElement)['pointerEvents'] !== 'none') {
                    _this.status = true;
                    _this.leave = false;
                    if (!element.status) {
                        _this.options.onEnter(element);
                        if (_this.options.emitGlobal) {
                            var eventInit = {};
                            eventInit.detail = element;
                            var customEvent = new CustomEvent('apollo-enter', eventInit);
                            window.dispatchEvent(customEvent);
                        }
                    }
                    else {
                        _this.options.onMove(element);
                        if (_this.options.emitGlobal) {
                            var eventInit = {};
                            eventInit.detail = element;
                            var customEvent = new CustomEvent('apollo-move', eventInit);
                            window.dispatchEvent(customEvent);
                        }
                    }
                    element.status = true;
                    _this._distanceFromCenter = _this.setDistanceFromCenter(element.domElement, element.target.offset, element.rect);
                    _this._distanceFromBorder = _this.setDistanceFromBorder(element.domElement, element.target.offset, element.rect);
                    if (element.target.magnetism) {
                        _this.setMagnetism(element, delta);
                    }
                    element.domElement.classList.add('apollo--active');
                    if (_this.options.type === Apollo.TYPE.HTML)
                        _this.options.cursor.classList.add('apollo__cursor--active');
                }
                else if (element.domElement.classList.contains('apollo--active')) {
                    element.domElement.classList.remove('apollo--active');
                    element.status = false;
                    if (!_this.leave) {
                        _this.leave = true;
                        _this.options.onLeave(element);
                        if (_this.options.emitGlobal) {
                            var eventInit = {};
                            eventInit.detail = element;
                            var customEvent = new CustomEvent('apollo-leave', eventInit);
                            window.dispatchEvent(customEvent);
                        }
                        if (element.target.magnetism && element.target.magnetism.mode === 'push' && _this._pushing && !element.status) {
                            var coords = _this.easeMagnetism(_this._coords, element, delta);
                            _this.options.cursor.style.webkitTransform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
                            _this.options.cursor.style.transform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
                            _this._pushing = false;
                        }
                    }
                }
                else {
                    element.domElement.classList.remove('apollo--active');
                    if (element.target.magnetism) {
                        if (element.target.magnetism.mode === 'pull') {
                            var coords = _this.easeMagnetism({ x: 0, y: 0 }, element, delta);
                            if (Math.round(coords.y) !== 0 || Math.round(coords.x) !== 0) {
                                element.domElement.style.webkitTransform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
                                element.domElement.style.transform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
                            }
                            else {
                                element.domElement.style.removeProperty('webkit-transform');
                                element.domElement.style.removeProperty('transform');
                                element.domElement.style.removeProperty('z-index');
                            }
                            _this._pulling = false;
                        }
                    }
                }
            });
            if (!_this.status) {
                if (_this.options.type === Apollo.TYPE.HTML) {
                    _this.options.cursor.classList.remove('apollo__cursor--active');
                }
            }
        };
        this.setMagnetism = function (element, delta) {
            var magnetism = element.target.magnetism;
            var mode = magnetism.mode;
            if (mode === 'pull') {
                _this.pull(element, delta);
            }
            else if (mode === 'push') {
                _this.push(element, delta);
            }
        };
        this.pull = function (element, delta) {
            _this._pulling = true;
            var coordsTemp = {
                x: _this._coords.x - (element.rect.bounding.left + element.rect.bounding.center.x) + _this._boundingCursor.x,
                y: _this._coords.y - (element.rect.bounding.top + element.rect.bounding.center.y) + _this._boundingCursor.y,
            };
            var coords = _this.easeMagnetism(coordsTemp, element, delta);
            element.domElement.style.webkitTransform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
            element.domElement.style.transform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
            element.domElement.style.zIndex = '10';
        };
        this.push = function (element, delta) {
            if (!element.status)
                return;
            if (!_this._pushing) {
                element.timeline.initial = {
                    x: _this._cursorPosition.x,
                    y: _this._cursorPosition.y,
                };
            }
            _this._pushing = true;
            var coordsTemp = utils_1.pushMode(element, _this._boundingCursor);
            var coords = _this.easeMagnetism(coordsTemp, element, delta);
            if (_this.options.type === Apollo.TYPE.HTML) {
                _this.options.cursor.style.webkitTransform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
                _this.options.cursor.style.transform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0px)";
            }
        };
        this.easeMagnetism = function (tempCoords, element, delta) {
            element.timeline.final = {
                x: tempCoords.x,
                y: tempCoords.y,
            };
            var deltaT = Math.min(Math.max(delta, 0), element.target.magnetism.easing.duration);
            var t = element.target.magnetism.easing.mode(deltaT / element.target.magnetism.easing.duration);
            element.timeline.current.x = element.timeline.initial.x + (t * (element.timeline.final.x - element.timeline.initial.x));
            element.timeline.current.y = element.timeline.initial.y + (t * (element.timeline.final.y - element.timeline.initial.y));
            var coords = {
                x: element.timeline.current.x,
                y: element.timeline.current.y,
            };
            element.timeline.initial.x = element.timeline.current.x;
            element.timeline.initial.y = element.timeline.current.y;
            return coords;
        };
        this.setElBounding = function (el, offset) {
            var bounding = el.getBoundingClientRect();
            var _bounding = bounding;
            _bounding.center = {
                x: bounding.width / 2,
                y: bounding.height / 2,
            };
            var offsetTemp = {
                x: 0,
                y: 0,
            };
            var _offset = __assign({}, offsetTemp, offset);
            return {
                bounding: _bounding,
                offset: _offset,
            };
        };
        this.initTargets = function () {
            _this.options.targets.forEach(function (target) {
                var _a;
                if (target.magnetism && target.magnetism.mode === Apollo.MODE.PUSH && target.magnetism.options === undefined) {
                    target.magnetism.options = Apollo.PUSH.CENTER;
                }
                target.elements.forEach(function (element, index) {
                    element.apolloId = target.id + "-" + index;
                    var obj = {
                        domElement: element,
                        apolloId: target.id + "-" + index,
                        target: target,
                        active: false,
                        timeline: {
                            initial: { x: 0, y: 0 },
                            current: { x: 0, y: 0 },
                            final: { x: 0, y: 0 },
                        },
                        rect: {},
                        status: false,
                    };
                    _this.elements.push(obj);
                });
                (_a = _this.domElements).push.apply(_a, target.elements);
            });
            return _this.domElements;
        };
        this.detachDomElements = function (elements) {
            if (elements !== null) {
                elements.forEach(function (element) {
                    _this.elements = _this.elements.filter(function (el) { return el.domElement.apolloId !== element.apolloId; });
                    _this.domElements = _this.domElements.filter(function (el) { return el.apolloId !== element.apolloId; });
                });
            }
            else {
                _this.elements = [];
                _this.domElements = [];
            }
            return {
                domElements: _this.domElements,
                elements: _this.elements,
            };
        };
        this.inRect = function (el, offset) {
            if (el === null)
                throw new Error('Element cannot be null');
            var rect = _this.setElBounding(el, offset);
            var coords = _this._coords;
            return {
                bounding: rect.bounding,
                offset: rect.offset,
                check: coords.x + _this._boundingCursor.x >= (rect.bounding.left - rect.offset.x)
                    && coords.y + _this._boundingCursor.y >= (rect.bounding.top - rect.offset.y)
                    && coords.x + _this._boundingCursor.x <= (rect.bounding.right + rect.offset.x)
                    && coords.y + _this._boundingCursor.y <= (rect.bounding.bottom + rect.offset.y),
            };
        };
        this.addTargets = function (targets) {
            var _a;
            targets.forEach(function (target) {
                var _a;
                if (target.magnetism && target.magnetism.mode === Apollo.MODE.PUSH && target.magnetism.options === undefined) {
                    target.magnetism.options = Apollo.PUSH.CENTER;
                }
                target.elements.forEach(function (element, index) {
                    element.apolloId = target.id + "-" + index;
                    var obj = {
                        domElement: element,
                        apolloId: target.id + "-" + index,
                        target: target,
                        active: false,
                        timeline: {
                            initial: { x: 0, y: 0 },
                            current: { x: 0, y: 0 },
                            final: { x: 0, y: 0 },
                        },
                        rect: {},
                        status: false,
                    };
                    _this.elements.push(obj);
                });
                (_a = _this.domElements).push.apply(_a, target.elements);
            });
            (_a = _this.options.targets).push.apply(_a, targets);
            return _this.options.targets;
        };
        this.removeTarget = function (targetId) {
            var targets = _this.options.targets.filter(function (target) { return target.id === targetId; });
            _this.options.targets = _this.options.targets.filter(function (target) { return target.id !== targetId; });
            targets.forEach(function (target) {
                _this.detachDomElements(target.elements);
            });
            return _this.options.targets;
        };
        var defaults = {
            mode: declarations_1.FOLLOW.CURSOR,
            cursor: document.querySelector('.apollo__cursor'),
            type: Apollo.TYPE.HTML,
            easing: {
                mode: Apollo.EASING.LINEAR,
                duration: 1000,
            },
            targets: [],
            hiddenUntilFirstInteraction: false,
            detectTouch: false,
            emitGlobal: false,
            renderByPixel: false,
            onUpdate: function () { },
            onEnter: function () { },
            onMove: function () { },
            onLeave: function () { },
            aion: null,
            autoStart: false,
        };
        this.options = __assign({}, defaults, options);
        this.frameHandler = function (delta) { return _this.frame(delta); };
        this.cursorCheckHandler = function (delta) { return _this.cursorCheck(delta); };
        this.bindMouse();
        this.initTargets();
        if (this.options.type === Apollo.TYPE.HTML) {
            this.setBoundingCursor();
        }
        if (this.options.hiddenUntilFirstInteraction && this.options.type === Apollo.TYPE.HTML) {
            this.options.cursor.style.display = 'none';
        }
        else {
            this.first = false;
        }
        this.timelineCursor = {
            initial: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
            current: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
            final: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
        };
        this._coords = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        this._mousePosition = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        this._cursorPosition = { x: window.innerWidth / 2 - this._boundingCursor.x, y: window.innerHeight / 2 - this._boundingCursor.y };
        if (this.options.type === Apollo.TYPE.HTML) {
            this.options.cursor.style.webkitTransform = "translate3d(" + this._cursorPosition.x + "px, " + this._cursorPosition.y + "px, 0px)";
            this.options.cursor.style.transform = "translate3d(" + this._cursorPosition.x + "px, " + this._cursorPosition.y + "px, 0px)";
        }
        if (this.options.aion === null || typeof this.options.aion === 'undefined') {
            this.engine = new aion_1.default();
        }
        else {
            this.engine = this.options.aion;
        }
        if (this.options.autoStart)
            this.engine.start();
        this.engine.add(this.frameHandler, 'cursorMove');
        this.engine.add(this.cursorCheckHandler, 'cursorCheck', true);
    }
    Object.defineProperty(Apollo.prototype, "mouse", {
        get: function () {
            return this._mousePosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "cursor", {
        get: function () {
            return this._cursorPosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "coords", {
        get: function () {
            return this._coords;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "velocity", {
        get: function () {
            return this._velocity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "direction", {
        get: function () {
            return this._direction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "boundingCursor", {
        get: function () {
            return this._boundingCursor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "distanceFromCenter", {
        get: function () {
            return this._distanceFromCenter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Apollo.prototype, "distanceFromBorder", {
        get: function () {
            return this._distanceFromBorder;
        },
        enumerable: true,
        configurable: true
    });
    Apollo.prototype.setCursorPosition = function (position) {
        this._mousePosition = position;
        return this._mousePosition;
    };
    Apollo.prototype.setDistanceFromCenter = function (el, offset, rect) {
        if (el === null)
            throw new Error('Element cannot be null');
        if (rect === undefined)
            rect = this.setElBounding(el, offset);
        var _left = (rect.bounding.left - rect.offset.x) - this._coords.x;
        var _top = (rect.bounding.top - rect.offset.y) - this._coords.y;
        var _right = (rect.bounding.right + rect.offset.x) - this._coords.x;
        var _bottom = (rect.bounding.bottom + rect.offset.y) - this._coords.y;
        var _center = {
            x: (_right - _left) / 2,
            y: (_bottom - _top) / 2,
        };
        var distance = {
            left: Math.abs(_left) + this._boundingCursor.x,
            top: Math.abs(_top) + this._boundingCursor.y,
            right: Math.abs(_right) - this._boundingCursor.x,
            bottom: Math.abs(_bottom) - this._boundingCursor.y,
        };
        var ratio = { x: 0, y: 0 };
        if (distance.left <= _center.x) {
            ratio.x = Math.round((distance.left / _center.x) * 100);
        }
        else {
            ratio.x = Math.round((distance.right / _center.x) * 100);
        }
        if (distance.top <= _center.y) {
            ratio.y = Math.round((distance.top / _center.y) * 100);
        }
        else {
            ratio.y = Math.round((distance.bottom / _center.y) * 100);
        }
        var distanceRatio = Math.min(Math.abs(ratio.x), Math.abs(ratio.y)) / 100;
        distanceRatio = Math.min(Math.max(distanceRatio, 0), 1);
        return distanceRatio;
    };
    Apollo.prototype.setDistanceFromBorder = function (el, offset, rect) {
        if (el === null)
            throw new Error('Element cannot be null');
        if (rect === undefined)
            rect = this.setElBounding(el, offset);
        var _left = (rect.bounding.left - rect.offset.x) - this._coords.x;
        var _top = (rect.bounding.top - rect.offset.y) - this._coords.y;
        var _right = (rect.bounding.right + rect.offset.x) - this._coords.x;
        var _bottom = (rect.bounding.bottom + rect.offset.y) - this._coords.y;
        var _center = {
            x: (_right - _left) / 2,
            y: (_bottom - _top) / 2,
        };
        var distance = {
            left: Math.abs(_left) - this._boundingCursor.x,
            top: Math.abs(_top) - this._boundingCursor.y,
            right: Math.abs(_right) - this._boundingCursor.x,
            bottom: Math.abs(_bottom) - this._boundingCursor.y,
        };
        var ratio = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
        };
        if (distance.left <= rect.offset.x) {
            ratio.x = Math.round((Math.abs(_left) / (rect.offset.x - (this._boundingCursor.x * 2))) * 100);
        }
        else {
            ratio.x = Math.round((Math.abs(_right) / rect.offset.x) * 100);
        }
        if (distance.top <= rect.offset.y) {
            ratio.y = Math.round((Math.abs(_top) / (rect.offset.y - (this._boundingCursor.y * 2))) * 100);
        }
        else {
            ratio.y = Math.round((Math.abs(_bottom) / rect.offset.y) * 100);
        }
        var distanceRatio = Math.min(Math.abs(ratio.x), Math.abs(ratio.y)) / 100;
        distanceRatio = Math.min(Math.max(distanceRatio, 0), 1);
        return distanceRatio;
    };
    Apollo.EASING = easing_1.default;
    Apollo.TYPE = declarations_1.TYPE;
    Apollo.MODE = declarations_1.MODE;
    Apollo.FOLLOW = declarations_1.FOLLOW;
    Apollo.PUSH = declarations_1.PUSH;
    return Apollo;
}());
exports.default = Apollo;
